<template>
  <footer class="pt-3 pb-3 bg-primary-alt">
    <div class="container">
      <div class="row justify-content-center text-center">
        <div class="col-xl-10">
          <small class="text-muted">Made in Paris, France.</small>
        </div>
      </div>
      <back-to-top bottom="50px" right="50px">
        <button type="button" class="btn btn-sm btn-primary btn-to-top">
          Back to top
          <i class="fa fa-chevron-up"></i>
        </button>
      </back-to-top>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style>
</style>